import React from 'react';
import { Link } from '@reach/router';
import 'react-lazy-load-image-component/src/effects/blur.css';

// LOCAL IMPORTS
import css from './index.module.scss';
import { homepageCategoryGA } from 'spwa-ui-library/esm/utils/helperGA';

export default function MediaGridList({ media, targetPath }) {
  return (
    targetPath && (
      <div className={css.tileWrapper}>
        <Link
          to={targetPath}
          className={css.tile}
          key={media.mediaUrl}
          onClick={() => homepageCategoryGA(media.title)}
        >
          <img
            className={css.image}
            src={`${media.mediaUrl}`}
            alt={media.title}
            wrapperClassName={css.lazy}
            effect="blur"
          />

          <div className={css.headingTitleContainer}>
            {media?.ribbonUrl ? (
              <>
                <img className={css.ribbon} src={`${media.ribbonUrl}`} alt="" />
                <div className={css.headingTitle}>{media.title}</div>
              </> ) : (
              <div className={css.onlyheadingTitle}>{media.title}</div>
            )}
          </div>
        </Link>
      </div>
    )
  );
}
